import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FireflySearchComponent } from './search.component';

@NgModule({
  declarations: [FireflySearchComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [FireflySearchComponent]
})
export class FireflySearchModule {}
